export default __webpack_public_path__ + "static/media/copyIcon.3916e0a8.svg";